import { makeStyles } from '@fluentui/react-components';

export const useDateTimeStyles = makeStyles({
  root: {
    display: 'flex',
    gap: '8px',
    width: '100%',
    marginBottom: '10px',
    '& > *': {
      flex: '1 1 0',
      minWidth: 0,
      overflow: 'hidden',
    },
  },
});
